import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { signal } from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideHammer, lucideArrowLeft, lucideHome } from '@ng-icons/lucide';
import { HlmIcon } from '@spartan-ng/helm/icon';
import { HlmButton } from '@spartan-ng/helm/button';

@Component({
  selector: 'app-forwarding-placeholder',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, NgIcon, HlmIcon, HlmButton],
  providers: [provideIcons({ lucideHammer, lucideArrowLeft, lucideHome })],
  template: `
    <div data-spartan-page
         class="flex items-center justify-center min-h-[60vh] p-6"
         style="background: rgb(var(--ds-bg, 250 250 249));">
      <div class="rounded-xl border border-border bg-card shadow-sm p-10 max-w-md w-full text-center">

        <div class="w-14 h-14 rounded-full bg-ds-accent-light flex items-center justify-center mx-auto mb-5">
          <ng-icon hlm name="lucideHammer" class="size-7 text-ds-accent" />
        </div>

        <h1 class="text-xl font-semibold tracking-tight mb-1">{{ pageTitle() }}</h1>
        <p class="text-xs font-semibold uppercase tracking-[0.08em] text-ds-accent mb-3">Phase 1C/D — Coming Soon</p>
        <p class="text-sm text-muted-foreground leading-relaxed mb-8">
          This page is being built as part of the Forwarding UX overhaul.
          The full implementation will be available in Phase 1C/D of the Forwarding Admin migration.
        </p>

        <div class="flex justify-center gap-2 flex-wrap">
          <a routerLink="/dashboard/forwarding/admin">
            <button hlmBtn variant="outline" class="gap-2 h-9">
              <ng-icon hlm name="lucideArrowLeft" class="size-4" />
              Back to Admin
            </button>
          </a>
          <a routerLink="/dashboard/forwarding">
            <button hlmBtn class="gap-2 h-9">
              <ng-icon hlm name="lucideHome" class="size-4" />
              Forwarding Home
            </button>
          </a>
        </div>

      </div>
    </div>
  `,
})
export class ForwardingPlaceholderComponent implements OnInit {
  private route = inject(ActivatedRoute);

  pageTitle = signal<string>('Coming Soon');

  ngOnInit(): void {
    const title = this.route.snapshot.data['title'] as string | undefined;
    if (title) {
      this.pageTitle.set(title);
    }
  }
}
